import { Modal } from 'react-daisyui';
import { Button } from 'components/Button';
import { PaymentSummary } from 'components/TreatmentPlan';

const PaymentDetailsModal = ({ isOpen, onClose, treatmentPlan }) => {
  let { paid_amount, amount_to_pay, payment_state } = treatmentPlan || {}
  let totalAmount = payment_state == 'payment_completed' ? paid_amount : amount_to_pay

  return (
    <Modal
      open={isOpen}
      onClose={onClose}
      backdrop
      className="max-w-xl rounded-3xl border-none shadow-2xl bg-white p-0 overflow-hidden"
    >
      <Modal.Body className="p-0 pb-6">
        <div className="p-6">
          <h2 className="text-xl font-bold text-secondary-900 leading-tight">Payment Details</h2>
          <p className="text-xs text-secondary-500 mt-1">Payment breakdown and financial information</p>
        </div>

        <PaymentSummary
          totalCost={totalAmount}
          paidToDate={paid_amount}
        />

        <div className="mx-6 mt-4">
          <Button
            title="Close"
            onClick={onClose}
            variant="tertiary"
            className="w-full py-3 rounded-2xl mt-4"
          />
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default PaymentDetailsModal;
